const ABTestsActionTypes = {
  ADD_ACTIVE_TESTS: 'ADD_ACTIVE_TESTS'
};

export default ABTestsActionTypes;
